// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__LwMAv","send_invite":"Button_send_invite__3BVL3"};